import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const NotificationCenter = () => {
  const [filter, setFilter] = useState('all');

  const notifications = [
    {
      id: 1,
      type: "price_alert",
      title: "Price Drop Alert",
      message: "Dragon Creature Pack is now 25% off - $89.99 (was $119.99)",
      timestamp: "2 hours ago",
      read: false,
      icon: "TrendingDown",
      color: "text-success"
    },
    {
      id: 2,
      type: "new_release",
      title: "New Release from FantasyArt3D",
      message: "Check out the latest Medieval Castle Bundle with 15 detailed models",
      timestamp: "5 hours ago",
      read: false,
      icon: "Sparkles",
      color: "text-primary"
    },
    {
      id: 3,
      type: "download_ready",
      title: "Download Ready",
      message: "Your purchase of Cyberpunk Vehicle Pack is ready for download",
      timestamp: "1 day ago",
      read: true,
      icon: "Download",
      color: "text-accent"
    },
    {
      id: 4,
      type: "community",
      title: "Assembly Featured",
      message: "Your \'Urban Environment\' assembly was featured in the community showcase",
      timestamp: "2 days ago",
      read: true,
      icon: "Award",
      color: "text-warning"
    },
    {
      id: 5,
      type: "system",
      title: "Account Security",
      message: "New login detected from San Francisco, CA. If this wasn't you, please secure your account",
      timestamp: "3 days ago",
      read: false,
      icon: "Shield",
      color: "text-error"
    },
    {
      id: 6,
      type: "social",
      title: "New Follower",
      message: "GameDev_Studio started following you and liked 3 of your assemblies",
      timestamp: "4 days ago",
      read: true,
      icon: "UserPlus",
      color: "text-secondary"
    }
  ];

  const filterOptions = [
    { value: 'all', label: 'All Notifications', count: notifications?.length },
    { value: 'unread', label: 'Unread', count: notifications?.filter(n => !n?.read)?.length },
    { value: 'price_alert', label: 'Price Alerts', count: notifications?.filter(n => n?.type === 'price_alert')?.length },
    { value: 'new_release', label: 'New Releases', count: notifications?.filter(n => n?.type === 'new_release')?.length },
    { value: 'community', label: 'Community', count: notifications?.filter(n => n?.type === 'community')?.length }
  ];

  const filteredNotifications = filter === 'all' 
    ? notifications 
    : filter === 'unread'
    ? notifications?.filter(n => !n?.read)
    : notifications?.filter(n => n?.type === filter);

  const handleMarkAsRead = (notificationId) => {
    console.log('Mark notification as read:', notificationId);
  };

  const handleMarkAllAsRead = () => {
    console.log('Mark all notifications as read');
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6 shadow-soft">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-foreground">Notifications</h2>
        
        <div className="flex items-center space-x-2">
          <Button 
            variant="outline" 
            size="sm" 
            iconName="CheckCheck"
            onClick={handleMarkAllAsRead}
          >
            Mark All Read
          </Button>
          <Button variant="ghost" size="sm" iconName="Settings">
            Settings
          </Button>
        </div>
      </div>
      {/* Filter Tabs */}
      <div className="flex flex-wrap gap-2 mb-6 border-b border-border">
        {filterOptions?.map((option) => (
          <button
            key={option?.value}
            onClick={() => setFilter(option?.value)}
            className={`flex items-center space-x-2 px-3 py-2 text-sm font-medium rounded-t-lg transition-smooth ${
              filter === option?.value
                ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
            }`}
          >
            <span>{option?.label}</span>
            {option?.count > 0 && (
              <span className={`px-2 py-1 text-xs rounded-full ${
                filter === option?.value
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {option?.count}
              </span>
            )}
          </button>
        ))}
      </div>
      {/* Notifications List */}
      <div className="space-y-3">
        {filteredNotifications?.map((notification) => (
          <div 
            key={notification?.id} 
            className={`flex items-start space-x-4 p-4 rounded-lg border transition-smooth hover:bg-muted/30 ${
              notification?.read 
                ? 'border-border bg-transparent' :'border-primary/20 bg-primary/5'
            }`}
          >
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 ${
              notification?.read ? 'bg-muted' : 'bg-primary/10'
            }`}>
              <Icon 
                name={notification?.icon} 
                size={18} 
                className={notification?.read ? 'text-muted-foreground' : notification?.color}
              />
            </div>
            
            <div className="flex-1 min-w-0">
              <div className="flex items-start justify-between mb-1">
                <h3 className={`text-sm font-medium ${
                  notification?.read ? 'text-muted-foreground' : 'text-foreground'
                }`}>
                  {notification?.title}
                </h3>
                
                <div className="flex items-center space-x-2 ml-4">
                  {!notification?.read && (
                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                  )}
                  <span className="text-xs text-muted-foreground whitespace-nowrap">
                    {notification?.timestamp}
                  </span>
                </div>
              </div>
              
              <p className={`text-sm leading-relaxed ${
                notification?.read ? 'text-muted-foreground' : 'text-foreground'
              }`}>
                {notification?.message}
              </p>
              
              {!notification?.read && (
                <div className="flex items-center space-x-2 mt-3">
                  <Button 
                    variant="ghost" 
                    size="sm"
                    onClick={() => handleMarkAsRead(notification?.id)}
                  >
                    Mark as Read
                  </Button>
                  
                  {notification?.type === 'price_alert' && (
                    <Button variant="outline" size="sm" iconName="ShoppingCart">
                      View Deal
                    </Button>
                  )}
                  
                  {notification?.type === 'download_ready' && (
                    <Button variant="outline" size="sm" iconName="Download">
                      Download
                    </Button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
      {filteredNotifications?.length === 0 && (
        <div className="text-center py-12">
          <Icon name="Bell" size={48} className="text-muted-foreground mx-auto mb-4" />
          <h3 className="text-lg font-medium text-foreground mb-2">No notifications</h3>
          <p className="text-sm text-muted-foreground">
            {filter === 'all' ? "You're all caught up! No new notifications." 
              : `No ${filter?.replace('_', ' ')} notifications found.`}
          </p>
        </div>
      )}
    </div>
  );
};

export default NotificationCenter;